import React, { useEffect, useState } from 'react';
import useAxios from 'axios-hooks';
import {
  Flex,
  FormLabel,
  SimpleGrid,
  FormControl,
  useColorModeValue,
  Text,
  Center,
  Button,
  ButtonSpinner,
  Spinner,
} from '@chakra-ui/react';
import Card from 'components/Card/Card.js';
import { checkLogin } from '../../utils/authentication';
import { useHistory } from 'react-router-dom';
import { API_ROUTES } from 'utils/constant';
import { formatDate } from 'utils/helpers';
import IconBox from 'components/Icons/IconBox';
import moment from 'moment';
import DatePicker from 'components/DatePicker/DatePicker';
import { MdEmail } from 'react-icons/md';
import CardHeader from 'components/Card/CardHeader';

export default function Dashboard() {
  const textColor = useColorModeValue('gray.700', 'white');
  const isLoggedIn = checkLogin();
  const history = useHistory();
  const [filterDate, setFilterDate] = useState({
    start: new Date(moment().startOf('day')),
    end: new Date(moment().endOf('day')),
  });

  const [{ data: dataMonthBill, loading: billLoading }, refetch] = useAxios(
    {
      url: API_ROUTES.MonthBill,
      params: {
        ...filterDate,
      },
    },
    {
      useCache: false,
      manual: true,
    }
  );
  const [{ data: dataOtpMonthBill, loading: billOtpLoading }, refetchOtp] = useAxios(
    {
      url: API_ROUTES.OtpMonthBill,
      params: {
        ...filterDate,
      },
    },
    {
      useCache: false,
      manual: true,
    }
  );

  useEffect(() => {
    if (!isLoggedIn) {
      return history.push('/auth/signin');
    }
  }, [isLoggedIn, history]);

  useEffect(() => {
    handleRefetchData();
  }, []);

  const handleRefetchData = params => {
    refetch({
      params: { ...filterDate, ...params },
    })
      .then(res => {})
      .catch(error => {});
    refetchOtp({
      params: { ...filterDate, ...params },
    })
      .then(res => {})
      .catch(error => {});
  };

  const onChangeDate = type => date => {
    setFilterDate(prev => ({
      ...prev,
      ...(type === 'start' && { end: new Date(formatDate(moment(date).add(1, 'months'))) }),
      [type]: date,
    }));
  };

  const onFilter = () => {
    handleRefetchData();
  };

  const onClearFilter = () => {
    setFilterDate({
      start: new Date(moment().startOf('day')),
      end: new Date(moment().endOf('day')),
    });
    handleRefetchData({
      start: new Date(moment().startOf('day')),
      end: new Date(moment().endOf('day')),
    });
  };

  return (
    <>
      <Card overflowX={{ sm: 'scroll', xl: 'hidden' }} pb="0px" p="10" mt={{ base: '120px', md: '75px' }}>
        <CardHeader p="6px 0px 22px 0px">
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            Thống kê
          </Text>
          <Flex alignItems={'center'} gap={'20px'} flexWrap={'wrap'}>
            <FormControl width={{ base: 'full', sm: '300px' }}>
              <Flex alignItems={'center'} gap={4}>
                <FormControl display="flex" flexDirection="column">
                  <FormLabel marginRight={0} fontSize={14} isTruncated>
                    Ngày bắt đầu
                  </FormLabel>
                  <DatePicker
                    styleInput={{
                      minWidth: '300px',
                    }}
                    selectedDate={filterDate.start}
                    onChange={date => onChangeDate('start')(date)}
                  />
                </FormControl>
                <FormControl display="flex" flexDirection="column">
                  <FormLabel marginRight={0} fontSize={14} isTruncated>
                    Ngày kết thúc
                  </FormLabel>
                  <DatePicker
                    styleInput={{
                      minWidth: '300px',
                    }}
                    selectedDate={filterDate.end}
                    minDate={filterDate.start}
                    maxDate={new Date(formatDate(moment(filterDate.start).add(1, 'months')))}
                    onChange={date => onChangeDate('end')(date)}
                  />
                </FormControl>
              </Flex>
            </FormControl>
            <Button variant="primary" maxH="30px" m="10px" alignSelf={'flex-end'} isLoading={billLoading} onClick={onFilter}>
              Lọc
            </Button>
            <Button variant="primary" maxH="30px" m="10px" alignSelf={'flex-end'} isLoading={billLoading} onClick={onClearFilter}>
              Đặt lại
            </Button>
          </Flex>
          <div>Thống kê chỉ ghi nhận các thư gửi đi THÀNH CÔNG</div>
        </CardHeader>
        <Flex flexDirection="column">
          <SimpleGrid columns={{ sm: 1, md: 2, xl: 3 }} spacing="24px" mb="20px">
            <StatisticalData
              title="8DAY CRM"
              value={dataMonthBill?.data?.mail8day || 0}
              icon={
                <IconBox borderRadius="50%" as="box" h={'45px'} w={'45px'} mr={'16px'}>
                  <MdEmail size={'45'} />
                </IconBox>
              }
              isLoading={billLoading}
            />
            <StatisticalData
              title="888B CRM"
              value={dataMonthBill?.data?.mail888b || 0}
              icon={
                <IconBox borderRadius="50%" as="box" h={'45px'} w={'45px'} mr={'16px'}>
                  <MdEmail size={'45'} />
                </IconBox>
              }
              isLoading={billLoading}
            />
            <StatisticalData
              title="2Q CRM"
              value={dataMonthBill?.data?.mail2q || 0}
              icon={
                <IconBox borderRadius="50%" as="box" h={'45px'} w={'45px'} mr={'16px'}>
                  <MdEmail size={'45'} />
                </IconBox>
              }
              isLoading={billLoading}
            />
            <StatisticalData
              title="Đăng ký 8DAY"
              value={dataMonthBill?.data?.mailRegistration || 0}
              icon={
                <IconBox borderRadius="50%" as="box" h={'45px'} w={'45px'} mr={'16px'}>
                  <MdEmail size={'45'} />
                </IconBox>
              }
              isLoading={billLoading}
            />
            <StatisticalData
              title="OTP 8DAY"
              value={dataOtpMonthBill?.data?.total8day || 0}
              icon={
                <IconBox borderRadius="50%" as="box" h={'45px'} w={'45px'} mr={'16px'}>
                  <MdEmail size={'45'} />
                </IconBox>
              }
              isLoading={billOtpLoading}
            />
            <StatisticalData
              title="OTP 888B"
              value={dataOtpMonthBill?.data?.total888b || 0}
              icon={
                <IconBox borderRadius="50%" as="box" h={'45px'} w={'45px'} mr={'16px'}>
                  <MdEmail size={'45'} />
                </IconBox>
              }
              isLoading={billOtpLoading}
            />
            <StatisticalData
              title="OTP 2Q"
              value={dataOtpMonthBill?.data?.total2q || 0}
              icon={
                <IconBox borderRadius="50%" as="box" h={'45px'} w={'45px'} mr={'16px'}>
                  <MdEmail size={'45'} />
                </IconBox>
              }
              isLoading={billOtpLoading}
            />
          </SimpleGrid>
        </Flex>
      </Card>
    </>
  );
}

const StatisticalData = props => {
  const { title, value, icon, href, isLoading } = props;
  const textColor = useColorModeValue('gray.700', 'white');

  return (
    <Card minH="125px" bgColor="white" borderRadius="8px">
      <Flex justifyContent={'space-between'}>
        <Flex flexDirection={'column'}>
          <Text fontSize="2xl" color={textColor} fontWeight="bold">
            {title}
          </Text>
          <Flex direction="row" mt={'16px'} ml={'32px'}>
            <Center>
              {icon}
              {isLoading ? (
                <ButtonSpinner className="" position={'relative'}>
                  <Spinner color="currentColor" width="1em" height="1em" />
                </ButtonSpinner>
              ) : (
                <Text fontSize="5xl" color={textColor} fontWeight="900">
                  {value}
                </Text>
              )}
            </Center>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};
